// Die Navigation aus docs/design.md. Jede Seite gibt es zweimal: kundenweit
// ("Alle Kunden") ohne Präfix und je Kunde unter /k/<kunde-slug>/<seite>.

export interface PageDef {
  /** Pfadsegment; leer für die Übersicht. */
  readonly segment: string
  readonly label: string
  /** Zeigt die Zahl offener Alarme als Badge. */
  readonly badge?: 'alerts'
  /** Recht, ohne das der Eintrag gar nicht erscheint. */
  readonly permission?: 'view' | 'settings.manage' | 'user.manage' | 'config.view'
}

export const PAGES: readonly PageDef[] = [
  { segment: '', label: 'Übersicht' },
  { segment: 'alarme', label: 'Alarme', badge: 'alerts' },
  { segment: 'geraete', label: 'Geräte' },
  { segment: 'standorte', label: 'Standorte & Agents' },
  { segment: 'fernzugriff', label: 'Fernzugriff' },
  { segment: 'configs', label: 'Config-Backups', permission: 'config.view' },
  { segment: 'portfinder', label: 'Port-Finder' },
  { segment: 'topologie', label: 'Topologie' },
  { segment: 'dienste', label: 'Dienste & CMDB' },
  { segment: 'syslog', label: 'Syslog' },
  { segment: 'berichte', label: 'Berichte' },
  { segment: 'einstellungen', label: 'Einstellungen', permission: 'settings.manage' },
]

/** Baut den Pfad einer Seite im aktuellen Kundenkontext. */
export function pagePath(segment: string, customerSlug: string | null): string {
  const base = customerSlug ? `/k/${customerSlug}` : ''
  if (!segment) return base || '/'
  return `${base}/${segment}`
}
